import React from "react";

import { FIELD_TYPE, FORMAT_TIME, tabKeys, TT_PHIEU_VTYT } from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import { ColumnProps } from "../../../../../types/models";
import { listGender } from "../../../../../data/list";
import { trangThaiPKOptions } from "../../../../../assets/constants/select-catagory-options";
import { formatNumber, formatToCurrencyType } from "helper/common";
import dayjs from 'dayjs';

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER,DATE_DISABLE_NO_DAY } = FIELD_TYPE;
function formatNumberTo(number: number | string): string {
  const numString: string = number.toString();
  const parts: string[] = numString.split('.');

  // Phần nguyên
  const integerPart: string = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Phần thập phân (nếu có)
  const decimalPart: string = parts[1] ? `,${parts[1]}` : '';

  // Kết hợp phần nguyên và thập phân để tạo số đã được định dạng
  const formattedNumber: string = integerPart + decimalPart;

  return formattedNumber;
}
const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 30,
    align: "center",
    isResizable: true,
  },
  {
    title: "Tên nhân viên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    align: "left",
    width: 80,
    isResizable: true,
  },
  {
    title: "Mã đăng ký",
    key: "maDangKy",
    show: true,
    dataIndex: "maDangKy",
    align: "center",
    width: 80,
    isResizable: true,
  },
  {
    title: "Ngày đăng ký",
    key: "ngayDangKy",
    show: true,
    dataIndex: "ngayDangKy",
    align: "center",
    width: 80,
    isResizable: true,
    render: (v, r, idx) => v !== null ? dayjs(v).format("HH:mm DD/MM/YYYY") : null ,
  },
  {
    title: "Loại nghỉ phép",
    key: "loaiNghiPhep",
    show: true,
    dataIndex: "loaiNghiPhep",
    isResizable: true,
    align: "left",
    width: 180,
  },
  {
    title: "Lý do",
    key: "lyDo",
    show: true,
    dataIndex: "lyDo",
    align: "left",
    width: 140,
    isResizable: true,
  },
  {
    title: "Trạng thái",
    key: "trangThai",
    show: true,
    dataIndex: "trangThai",
    align: "center",
    width: 140,
    isResizable: true,
  },
  {
    title: "Tác vụ",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 70,
    key: "action",
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    name: "idNhanVien",
    label: "Tên nhân viên",
    expand: false,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "thoiGianTu",
    expand: false,
    label: "Thời gian từ",
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "thoiGianDen",
    expand: false,
    label: "Thời gian đến",
  },
];

export {allColumns, itemsInputField };
